import { useState } from 'react';
const useMenu = () => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    return { open, anchorEl, setAnchorEl };
};
export default useMenu;
